<script setup lang="ts">
/**
 * Draft mode exit, for both www and business: the preview cookie is domain-wide, so an editor
 * browsing outside Presentation needs a visible way out. Self-gates on `isDraftMode`.
 */
import { useDraftMode } from '@pkg/sanity-utils/composables/useDraftMode';

const route = useRoute();
const { isDraftMode } = useDraftMode();
</script>

<template>
  <aside v-if="isDraftMode" class="draft-mode-bar">
    <a class="w-full inline-block" :href="`/_sanity/preview/disable?redirect=${route.fullPath}`">Draft Preview Mode - click to exit</a>
  </aside>
</template>

<style scoped>
.draft-mode-bar {
  background-color: #ffe1d1;
  bottom: 0;
  color: #333333;
  left: 0;
  padding: 4px 8px;
  position: fixed;
  text-align: center;
  width: 100%;
  z-index: theme('zIndex.draftModeBar')
}
</style>
